var map = {
	"./acceptance.svg": "2db8",
	"./admiration.svg": "787d3",
	"./amusement.svg": "3396",
	"./anger.svg": "0939",
	"./annoyance.svg": "d0a0",
	"./anxiety.svg": "3a06",
	"./boredom.svg": "7603",
	"./confusion.svg": "e123",
	"./delight.svg": "33e9",
	"./disappointment.svg": "c219",
	"./disgust.svg": "f8d1",
	"./embarrassment.svg": "5dc2",
	"./expectation.svg": "5ee8",
	"./fear.svg": "cdfd",
	"./grief.svg": "7038",
	"./guilt.svg": "1cb6",
	"./horror.svg": "9d24",
	"./interest.svg": "92f3",
	"./joy.svg": "e55e",
	"./rage.svg": "f591",
	"./sadness.svg": "39d1",
	"./serenity.svg": "d3f6",
	"./shame.svg": "5aa7",
	"./surprise.svg": "565a",
	"./trust.svg": "c8e3",
	"./wariness.svg": "07ad",
	"./yearning.svg": "e8f1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8595";